import { useParams } from 'react-router-dom';

import { SiteDetails } from '@/components/pages/assets/overview/site-details';
import { SiteMetadata } from '@/components/pages/assets/overview/site-metadata';
import { WhiteLabelChargeDischarge } from '@/components/pages/assets/overview/white-label-charge-discharge';
import { WhiteLabelErrors } from '@/components/pages/assets/overview/white-label-errors';
import { WhiteLabelInverterOnlines } from '@/components/pages/assets/overview/white-label-inverter-onlines';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { useMe } from '@/hooks/use-me';

export function AssetOverviewPage() {
  const me = useMe();
  const featureFlag = useFeatureFlag();
  const { siteId } = useParams<{ siteId: string }>();

  return (
    <div
      data-testid="asset-overview-page"
      className="mx-auto flex max-w-screen-xl flex-col gap-4 p-8 xl:py-16"
    >
      <SiteDetails siteId={siteId} />
      {me.whiteLabel ? <WhiteLabelInverterOnlines /> : null}
      {me.whiteLabel ? <WhiteLabelChargeDischarge /> : null}
      {me.whiteLabel ? <WhiteLabelErrors /> : null}
      {featureFlag('recordsMetadata') ? <SiteMetadata siteId={siteId} /> : null}
    </div>
  );
}
